import React from 'react'
import { Display, Body } from 'shared-global-ec-uikit/components/dist/react/esm'
import { getStoreNameWithStatus } from 'services/Stores/utils'
import Parser from 'html-react-parser'

const StoreNameWithStatus = (props: any) => {
  const {
    businessStatusShortComment,
    irregularOpenTimeShortComment,
  } = props.storeInfo
  return (
    <>
      <Display
        color="primary-dark"
        element="p"
        maxLinesEllipsis={0}
        textAlign="left"
        textTransform="normal"
        variant="display4"
        className={
          businessStatusShortComment || irregularOpenTimeShortComment
            ? 'fr-ec-mb-spacing-04'
            : ''
        }
      >
        {props.storeInfo.name}
      </Display>
      <Body
        color="primary-dark"
        element="p"
        textAlign="left"
        textTransform="normal"
        variant="standard"
        className="fr-ec-mb-spacing-02"
      >
        {getStoreNameWithStatus(props.storeInfo, true)}
      </Body>
      {props.storeInfo.announcement && (
        <Body
          color="primary-dark"
          element="p"
          textAlign="left"
          textTransform="normal"
          variant="standard"
        >
          {Parser(props.storeInfo.announcement)}
        </Body>
      )}
    </>
  )
}

export default StoreNameWithStatus
